import { useSelector } from 'react-redux';
import * as React from 'react';
import { Container } from '../../components/Container';
import { useRecommendationsEventsSubscribe } from './hooks/useRecommendationsEventsSubscribe';
import { ELandingType } from '../../types/landingType';
import { selectRegionId } from '../../selectors/filters/selectRegionId';
import { Recommendations } from '../../components/Recommendations';
import { useMicrofrontend } from '@cian/mf-react-legacy';
import { isRecommendationsMicrofrontendExists } from './utils/isRecommendationsMicrofrontendExists';

export const RecommendationsContainer = () => {
  const microfrontend = useMicrofrontend();
  const regionId = useSelector(selectRegionId);

  useRecommendationsEventsSubscribe();

  /* istanbul ignore next */
  if (!isRecommendationsMicrofrontendExists(microfrontend)) {
    return null;
  }

  return (
    <Container>
      <Recommendations regionId={regionId} landingType={ELandingType.SuburbanSale} />
    </Container>
  );
};
